<template>
  <div style="height:100%;width: 100%;padding: 0 20px;box-sizing: border-box">
    <div style="height: 40px;width: 420px;float: right;margin-top: -55px;display: flex;text-align: right">
      <el-date-picker v-fixZoom :clearable="false" v-model="sendDate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
                      style="margin-right: 10px; width: 160px" class="datePicker-query">
      </el-date-picker>
      <el-button type="primary" @click="getTableHistoryHealthPerson">查询</el-button>
      <el-select v-fixZoom v-model="sleepId" filterable  placeholder="请选择" style="width: 160px;margin-left: 10px" class="datePicker-query" @change="getEndSleepShow">
        <el-option v-for="item in sleepReport" :key="item.value" :label="item.showTime" :value="item.id">
        </el-option>
      </el-select>
    </div>
    <el-row style="height: 100%">
      <el-col :span="8">
        <div class="health-title-top">睡眠情况</div>
        <div style="display: flex;margin-top: 30px">
          <div class="person-icon" style="margin-left: 85px"></div>
          <div style="flex: 1;margin-left: 55px">
            <div style="font-weight: 700;font-size: 24px;color: #FFFFFF;">睡眠评分</div>
            <div style="font-weight: 900;font-size: 40px;color: #29F1FA;"><span v-if="sleepData.sr_sleep_score">{{sleepData.sr_sleep_score}}</span><span v-else>-</span></div>
            <div style="display: flex;margin-top: 20px">
              <div style="width: 11px">
                <div style="width: 9px;height: 20px;background: #1A3738;"></div>
                <div style="width: 9px;height: 47px;background: #61C5C7;"></div>
              </div>
              <div style="flex: 1;margin-left: 10px">
                <div style="height: 20px;font-size: 18px;color: #B7CAFD;">
                  <img style="vertical-align: middle" src="../../../assets/health/icon_sleep.png">
                  <span style="vertical-align: middle">总时长</span>
                </div>
                <div style="margin-top: 20px;font-size: 25px;color: #FFFFFF;height: 30px;letter-spacing: 2px">
                  <span>{{totalTime1}}</span><span style="font-size: 12px;">小时</span><span>{{ totalTime2 }}</span><span style="font-size: 12px;">分</span>
                </div>
              </div>
            </div>
            <div style="display: flex;margin-top: 20px">
              <div style="width: 11px">
                <div style="width: 9px;height: 20px;background: #1A3738;"></div>
                <div style="width: 9px;height: 47px;background: #E6BD37;"></div>
              </div>
              <div style="flex: 1;margin-left: 10px">
                <div style="height: 20px;font-size: 18px;color: #B7CAFD;">
                  <img style="vertical-align: middle" src="../../../assets/health/icon_sleep.png">
                  <span style="vertical-align: middle">睡眠质量</span>
                </div>
                <div style="margin-top: 18px;font-size: 25px;color: #FFFFFF;height: 30px;letter-spacing: 2px">
                  <span>一般</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="font-size: 16px;color: #29F1FA;margin-top: 20px">上一次在线时间：{{sleepStatus.time}}</div>
        <el-row style="margin-top: 10px">
          <el-col :span="12">
            <div style="display: flex">
              <div style="width: 67px;height: 66px"><img src="../../../assets/health/icon_xinlv.png"/></div>
              <div style="flex: 1;margin-left: 10px">
                <div class="icon-bg">心率</div>
                <div class="icon-text">{{ sleepStatus.heartbeat }}<span style="font-size: 12px;margin-left: 5px">次</span></div>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div style="display: flex">
              <div style="width: 67px;height: 66px"><img src="../../../assets/health/icon_huxi.png"/></div>
              <div style="flex: 1;margin-left: 10px">
                <div class="icon-bg">呼吸</div>
                <div class="icon-text">{{ sleepStatus.breathe }}<span style="font-size: 12px;margin-left: 5px">次</span></div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="12">
            <div style="display: flex">
              <div style="width: 67px;height: 66px"><img src="../../../assets/health/icon_zt.png"/></div>
              <div style="flex: 1;margin-left: 10px">
                <div class="icon-bg">状态</div>
                <div class="icon-text">
                  <span v-if="sleepStatus.inbed === 0" style="color: #FB651F">离床</span>
                  <span v-else-if="sleepStatus.inbed === 1">
                      <span v-if="sleepStatus.status === 0">正常</span>
                      <span v-if="sleepStatus.status === 1">翻身</span>
                      <span v-if="sleepStatus.status === 2">安静</span>
                      <span v-if="sleepStatus.status === 3">动作</span>
                      <span v-if="sleepStatus.status === 4">持续动作</span>
                      <span v-if="sleepStatus.status === 5">无人</span>
                      <span v-if="sleepStatus.status === 6">平静</span>
                  </span>
                  <span v-else>-</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
      <el-col :span="8" style="height: 100%">
        <div style="height: 100%;margin-right: 20px;margin-top: 60px"><div class="ren-bg"></div></div>
      </el-col>
      <el-col :span="8">
        <div class="health-title-top">睡眠数据统计</div>
        <el-row>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">深睡时长</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span>{{ deepSleep1 }}</span><span style="margin-left: 5px;font-size: 12px">小时</span>
                <span>{{ deepSleep2 }}</span><span style="margin-left: 5px;font-size: 12px">分钟</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">浅睡时长</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span>{{ lightSleep1 }}</span><span style="margin-left: 5px;font-size: 12px">小时</span>
                <span>{{ lightSleep2 }}</span><span style="margin-left: 5px;font-size: 12px">分钟</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">平均呼吸</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_avg_breath}}</span><span style="margin-left: 5px;font-size: 12px">次/分</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">平均心跳</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_avg_heartrate}}</span><span style="margin-left: 5px;font-size: 12px">次/分</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">离床次数</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span v-if="sleepData && sleepData !== '' && sleepData.sr_out_bed_times">{{sleepData.sr_out_bed_times}}</span>
                <span v-else>0</span><span style="margin-left: 5px;font-size: 12px">次</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">翻身次数</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_roll_over_times}}</span><span style="margin-left: 5px;font-size: 12px">次</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">离床时长</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span v-if="outBed1">{{ outBed1 }}</span><span v-else>0</span><span style="margin-left: 5px;font-size: 12px">小时</span>
                <span v-if="outBed2">{{ outBed2 }}</span><span v-else>0</span><span style="margin-left: 5px;font-size: 12px">分钟</span>
              </div>
            </div>
          </el-col>
          <el-col :span="12">
            <div class="card-item">
              <div style="display: flex;height: 20px">
                <div class="card-item-top">呼吸暂停</div>
                <div class="green-type"></div>
              </div>
              <div class="card-item-bottom">
                <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_breath_stop_times}}</span><span style="margin-left: 5px;font-size: 12px">次</span>
              </div>
            </div>
          </el-col>
        </el-row>
        <div>
          <div class="card-item" style="text-align: center">
            <el-row>
              <el-col :span="8">
                <div style="display: flex;height: 20px">
                  <div class="card-item-top">深睡占比</div>
                </div>
                <div class="card-item-bottom">
                  <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_deep_sleep_percent}}</span><span style="margin-left: 5px;font-size: 12px">%</span>
                </div>
              </el-col>
              <el-col :span="8">
                <div style="display: flex;height: 20px">
                  <div class="card-item-top">浅睡占比</div>
                </div>
                <div class="card-item-bottom">
                  <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_light_sleep_percent}}</span><span style="margin-left: 5px;font-size: 12px">%</span>
                </div>
              </el-col>
              <el-col :span="8" v-if="sleepData && sleepData !== '' && sleepData.sr_fast_eye_move_percent">
                <div style="display: flex;height: 20px">
                  <div class="card-item-top">快速眼动</div>
                </div>
                <div class="card-item-bottom">
                  <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_fast_eye_move_percent}}</span><span style="margin-left: 5px;font-size: 12px">%</span>
                </div>
              </el-col>
              <el-col :span="8" v-else>
                <div style="display: flex;height: 20px">
                  <div class="card-item-top">清醒占比</div>
                </div>
                <div class="card-item-bottom">
                  <span v-if="sleepData && sleepData !== ''">{{sleepData.sr_awake_percent}}</span><span style="margin-left: 5px;font-size: 12px">%</span>
                </div>
              </el-col>
            </el-row>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {querysleepreport, querysleepstatushistory} from '../../../api/yanglaoyuan'
export default {
  name: 'sleepReport',
  props: {
    healthObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      personHealthRow: '',
      sendDate: '',
      sleepReport: [], // 全部睡眠报告
      sleepId: 0,
      sleepData: '',
      totalTime1: 0,
      totalTime2: 0,
      outBed1: 0,
      outBed2: 0,
      deepSleep: 0,
      deepSleep1: 0,
      deepSleep2: 0,
      lightSleep: 0,
      lightSleep1: 0,
      lightSleep2: 0,
      awakeSleep: 0,
      awakeSleep1: 0,
      awakeSleep2: 0,
      eyeSleep: 0,
      eyeSleep1: 0,
      eyeSleep2: 0,
      sleepStatus: { // 最后在线时间
        heartbeat: 0,
        breathe: 0,
        inbed: '',
        time: '',
        status: ''
      }
    }
  },
  created () {
    console.log(this.healthObj)
    this.personHealthRow = this.healthObj.personHealthRow // 老人最新数据
    // eslint-disable-next-line no-extend-native
    Date.prototype.format = this.validate.format
    this.sendDate = this.commonType.GetDateStr(-1).format('yyyy-MM-dd')
    this.getTableHistoryHealthPerson()
  },
  methods: {
    getTableHistoryHealthPerson () {
      this.getTableHistoryHealthHistoryPerson()
      let day1 = this.sendDate
      // let day2 = this.commonType.GetNextDate(day1, 1).format('yyyy-MM-dd')
      let day2 = this.sendDate
      let data = {
        did: [],
        pid: this.personHealthRow.pid === '' ? 0 : this.personHealthRow.pid,
        from: day1 + ' 00:00:00',
        to: day2 + ' 23:59:59'
      }
      querysleepreport(data).then(res => {
        let arr = []
        console.log('==', arr)
        if (res.data.sleepData.device_sleep_report && res.data.sleepData.device_sleep_report.length > 0) {
          res.data.sleepData.device_sleep_report.forEach(item => {
            item.showTime = item.report_date.split(' ')[1]
            arr.push(item)
          })
          this.sleepReport = arr
          this.sleepId = res.data.sleepData.device_sleep_report[0].id
          this.getEndSleepShow()
        } else {
          this.$message.warning(`暂无睡眠报告`)
        }
      })
    },
    getTableHistoryHealthHistoryPerson () {
      let day1 = this.sendDate
      // let day2 = this.commonType.GetNextDate(day1, 1).format('yyyy-MM-dd')
      let day2 = this.sendDate
      let data = {
        did: [],
        pid: this.personHealthRow.pid === '' ? 0 : this.personHealthRow.pid,
        from: day1 + ' 00:00:00',
        to: day2 + ' 23:59:59'
      }
      querysleepstatushistory(data).then(res => {
        if (res.data.sleepData && res.data.sleepData.length > 0) {
          this.sleepStatus = res.data.sleepData[res.data.sleepData.length - 1]
        }
      })
    },
    getEndSleepShow () {
      let sleepData = ''
      this.sleepReport.forEach(item => {
        if (item.id === this.sleepId) {
          sleepData = item
        }
      })
      this.sleepData = sleepData
      let outBed1 = Math.floor(parseFloat(sleepData.sr_out_bed_duration) / 60)
      let outBed2 = parseFloat(sleepData.sr_out_bed_duration) % 60
      let totalTime1 = Math.floor(parseFloat(sleepData.sr_sleep_total_duration) / 60)
      let totalTime2 = parseFloat(sleepData.sr_sleep_total_duration) % 60
      this.totalTime1 = totalTime1
      this.totalTime2 = totalTime2
      this.outBed1 = outBed1
      this.outBed2 = outBed2
      let deepSleep = (parseFloat(sleepData.sr_deep_sleep_percent) / 100) * parseFloat(sleepData.sr_sleep_total_duration)
      let deepSleep1 = Math.floor(deepSleep / 60)
      let deepSleep2 = (deepSleep % 60).toFixed(0)
      let lightSleep = (parseFloat(sleepData.sr_light_sleep_percent) / 100) * parseFloat(sleepData.sr_sleep_total_duration)
      let lightSleep1 = Math.floor(lightSleep / 60)
      let lightSleep2 = (lightSleep % 60).toFixed(0)
      let awakeSleep = (parseFloat(sleepData.sr_awake_percent) / 100) * parseFloat(sleepData.sr_sleep_total_duration)
      let awakeSleep1 = Math.floor(awakeSleep / 60)
      let awakeSleep2 = (awakeSleep % 60).toFixed(0)

      let eyeSleep = (parseFloat(sleepData.sr_fast_eye_move_percent) / 100) * parseFloat(sleepData.sr_sleep_total_duration)
      let eyeSleep1 = Math.floor(eyeSleep / 60)
      let eyeSleep2 = (eyeSleep % 60).toFixed(0)

      this.deepSleep = deepSleep
      this.deepSleep1 = deepSleep1
      this.deepSleep2 = deepSleep2
      this.lightSleep = lightSleep
      this.lightSleep1 = lightSleep1
      this.lightSleep2 = lightSleep2
      this.awakeSleep = awakeSleep
      this.awakeSleep1 = awakeSleep1
      this.awakeSleep2 = awakeSleep2
      this.eyeSleep = eyeSleep
      this.eyeSleep1 = eyeSleep1
      this.eyeSleep2 = eyeSleep2
    }
  }
}
</script>

<style scoped>
.btn-send{
  width: 100px;
  height: 40px;
  background: #34B8FF;
  border-radius: 7px 7px 7px 7px;
  border: none;
  font-family: Source Han Sans, Source Han Sans;
  font-weight: 400;
  font-size: 20px;
  color: #FFFFFF;
}
.health-title-top {
  background: url("../../../assets/health/health_title_bg.png") no-repeat bottom;
  height: 35px;
  background-size: 100% 30px;
  padding-left: 50px;
  box-sizing: border-box;
  font-family: PingFang SC, PingFang SC;
  font-weight: 500;
  font-size: 20px;
  color: #29F1FA;
}
.ren-bg{
  background: url("../../../assets/health/ren.png") no-repeat;
  height: 433px;
  width: 403px;
  background-size: 100% 100%;
}
.person-icon{
  margin: 0 30px;
  width: 72px;
  height: 257px;
  background: #1D4D85;
  background: url("../../../assets/health/rt.png") no-repeat;
  background-size: 100% 100%;
}
.icon-bg{
  width: 107px;
  height: 24px;
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 17px;
  color: #FFFFFF;
  line-height: 24px;
  padding-left: 20px;
  box-sizing: border-box;
  background: url("../../../assets/health/bq.png") no-repeat;
  background-size: 100% 100%;
}
.icon-text{
  font-family: PingFang SC, PingFang SC;
  font-weight: 400;
  font-size: 22px;
  color: #34B8FF;
  height: 30px;
  line-height: 30px;
  margin-top: 12px;
}
.card-item{
  margin: 6px;
  background: #152F5D;
  border-radius: 6px 6px 6px 6px;
  border: 1px solid #34B8FF;
  padding: 11px;
  box-sizing: border-box;
}
.card-item-top{
  height: 20px;
  line-height: 20px;
  font-size: 16px;
  flex: 1;
  color: #FFFFFF;
}
.card-item-bottom{
  height: 28px;
  font-family: Roboto, Roboto;
  font-weight: 700;
  font-size: 26px;
  color: #FFFFFF;
  line-height: 28px;
  margin-top: 10px;
}
.red-type{
  margin-top: 3px;
  width: 8px;
  height: 8px;
  background: #FD3123;
  border-radius: 4px;
}
.green-type{
  margin-top: 3px;
  width: 8px;
  height: 8px;
  background: #29F1FA;
  border-radius: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/components/sleepReport.vue